import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Outlet, useLocation, useParams } from "react-router-dom";

import { AppDispatch } from "../../store";
import classes from "./Home.module.css";
import { getPODData } from "../../store/actions/PODActions";

const Home: React.FC<{}> = () => {
  const dispatch: AppDispatch = useDispatch();
  const { pathname } = useLocation();
  const { podId } = useParams();

  useEffect(() => {
    if (podId) {
      dispatch(getPODData(podId));
    }
  }, [podId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className={classes.main}>
      <Outlet />
    </div>
  );
};

export default Home;
